module.exports = __webpack_public_path__ + "904f3a1b4c54dfd33f1d5e2d8b87d7bf.jpg";


//////////////////
// WEBPACK FOOTER
// ./assets/images/main_photo.jpg
// module id = 1240
// module chunks = 0